module.exports = __webpack_public_path__ + "static/media/bf.34240a73.svg";